<template>
    <UserLayout page-title="Wallet Address Book" page-section="Settings">
        <div class="wab-page">

            <!-- Header strip -->
            <div class="wab-hero anim-up" style="--d:0ms">
                <div class="wab-hero-left">
                    <div class="wab-hero-icon">
                        <svg width="22" height="22" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
                        </svg>
                    </div>
                    <div>
                        <div class="wab-hero-eyebrow">Settings</div>
                        <div class="wab-hero-title">Wallet Address Book</div>
                    </div>
                </div>
                <a href="/user/settings" class="wab-back-btn">
                    <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
                    </svg>
                    Back to Settings
                </a>
            </div>

            <!-- Main card area -->
            <div class="wab-content anim-up" style="--d:60ms">
                <WalletAddressBookComponent :initial-wallets="walletAddresses" />
            </div>

        </div>
    </UserLayout>
</template>

<script setup>
import UserLayout from '@/Layouts/UserLayout/UserLayout.vue'
import WalletAddressBookComponent from '@/Components/User/Settings/WalletAddressBook.vue'
import { usePage } from '@inertiajs/vue3'
import { onMounted } from 'vue'
import { useToast } from '@/composables/useToast.js'

const props = defineProps({
    walletAddresses: { type: Array, default: () => [] }
})

const page = usePage()
const { showToast } = useToast()

onMounted(() => {
    const flash = page.props.flash
    if (flash?.success) showToast(flash.success, 'success')
    if (flash?.error)   showToast(flash.error, 'error')
})
</script>

<style scoped>
.anim-up { animation: slideUp 0.45s cubic-bezier(0.22,1,0.36,1) both; animation-delay: var(--d,0ms); }
@keyframes slideUp { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:none} }

.wab-page {
    position: relative;
    z-index: 10;
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 16px 14px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    box-sizing: border-box;
}
@media(min-width:640px)  { .wab-page{ padding: 20px 20px; gap: 16px; } }
@media(min-width:1024px) { .wab-page{ padding: 20px 24px; gap: 18px; } }

/* ── Hero strip ── */
.wab-hero {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    background: rgba(167,93,237,0.06);
    border: 1px solid rgba(167,93,237,0.16);
    border-radius: 13px;
    padding: 12px 16px;
}
.wab-hero-left { display: flex; align-items: center; gap: 10px; }
.wab-hero-icon {
    width: 40px; height: 40px; border-radius: 11px;
    background: linear-gradient(135deg,rgba(124,58,237,0.3),rgba(167,93,237,0.2));
    border: 1px solid rgba(167,93,237,0.28);
    display: flex; align-items: center; justify-content: center;
    color: #a75ded; flex-shrink: 0;
    box-shadow: 0 0 14px rgba(167,93,237,0.22);
}
.wab-hero-eyebrow { font-size: 9px; font-weight: 700; color: rgba(167,93,237,0.7); text-transform: uppercase; letter-spacing: 0.1em; }
.wab-hero-title { font-size: 15px; font-weight: 900; color: #fff; letter-spacing: -0.02em; }

.wab-back-btn {
    display: inline-flex; align-items: center; gap: 6px;
    padding: 6px 14px; border-radius: 9px;
    background: rgba(167,93,237,0.1); border: 1px solid rgba(167,93,237,0.22);
    color: #c084fc; font-size: 11px; font-weight: 700;
    text-decoration: none; transition: background 0.2s;
}
.wab-back-btn:hover { background: rgba(167,93,237,0.2); }

/* ── Content area ── */
.wab-content { width: 100%; }
</style>
